import { getJobDetail, createJob as putCreateJob, updateJob as putUpdateJob, saveJobActivity, updateJobApplication as putJobApplicationStatus, updateJobApplicationUserStatus as putJobApplicationUserStatus, loadAllJobApplication, saveJobApplication, loadJobApplication, loadJobApplications, loadAllJobActivity, doCsvUploadForJob, getSubOrganization as getSubOrg, createSubOrganization as putCreateSubOrg, updateSubOrganization as putUpdateSubOrg, getSubOrganizationsByParent, doCsvUploadForSubOrganization } from '../api'
import { getUserForEmployer } from '../../user/api'
import { getLearnerEnrollmentData } from '../../dashboard/api'


export const loadJobDetail = ({ state, commit }, uuid) => {
  return getJobDetail(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_JOB', data)
    }
    return data
  })
}
export const createJob = ({ state, commit }, job) => {
  return putCreateJob(job).then(data => {
    if (data !== undefined) {
      commit('LOAD_JOB', data)
    }
    return data
  })
}
export const updateJob = ({ state, commit }, job) => {
  return putUpdateJob(job).then(data => {
    if (data !== undefined) {
      commit('LOAD_JOB', data)
    }
    return data
  })
}
export const addJobActivity = ({ state, commit }, jobActivity) => {
  return saveJobActivity(jobActivity)
}
export const addJobApplication = ({ state, commit }, jobApplication) => {
  return saveJobApplication(jobApplication)
}
export const updateJobApplication = ({ state, commit }, application) => {
  return putJobApplicationStatus(application)
}
export const updateJobApplicationUserStatus = ({ state, commit }, {applicationId, status}) => {
  return putJobApplicationUserStatus(applicationId, status)
}
export const getJobApplication = ({ state, commit }, jobId) => {
  return loadJobApplication(jobId)
}
export const getJobApplications = ({ state, commit }) => {
  return loadJobApplications()
}
export const getAllJobApplication = ({ state, commit }, jobId) => {
  return loadAllJobApplication(jobId)
}
export const getAllJobActivity = ({ state, commit }, jobId) => {
  return loadAllJobActivity(jobId)
}

export const uploadJobCsvFile = ({ state, commit }, {institutionId, createdByUuid, folderId, fileData}) => {
  return doCsvUploadForJob(institutionId, createdByUuid, folderId, fileData).then(res => {
    return res
  })
}
export const loadApplicantEnrollmentData = ({ state, commit }, userId) => {
  if (!userId) {
    commit('LOAD_JOB_APPLICANT_ENROLLMENT_DATA', [])
    return Promise.resolve([])
  }
  commit('LOAD_JOB_APPLICANT_ENROLLMENT_DATA', [])
  return getLearnerEnrollmentData(userId).then(data => {
    commit('LOAD_JOB_APPLICANT_ENROLLMENT_DATA', data || [])
    return data
  })
}
export const loadJobApplicantUser = ({ commit }, applicantId) => {
  if (!applicantId) {
    commit('LOAD_JOB_USER_OBJECT', {})
    return Promise.resolve({})
  }
  return getUserForEmployer(applicantId).then(res => {
    commit('LOAD_JOB_USER_OBJECT', res || {})
    return res
  })
}
export const loadSubOrganization = ({ state, commit }, uuid) => {
  return getSubOrg(uuid)
}
export const createSubOrganization = ({ state, commit }, subOrg) => {
  return putCreateSubOrg(subOrg)
}
export const updateSubOrganization = ({ state, commit }, subOrg) => {
  return putUpdateSubOrg(subOrg)
}
export const loadSubOrganizationsByParent = ({ state, commit }, parentId) => {
  return getSubOrganizationsByParent(parentId)
}
export const uploadSubOrganizationCsvFile = ({ state, commit }, {parentId, createdByUuid, fileData}) => {
  return doCsvUploadForSubOrganization(parentId, createdByUuid, fileData)
}



// WEBPACK FOOTER //
// ./src/app/job/vuex/actions.js